import React, { useState } from 'react'

interface CompletionExceptionModalProps {
  open: boolean
  gateMessage?: string | null
  busy?: boolean
  onCancel: () => void
  onConfirm: (reason: string) => void | Promise<void>
}

export function CompletionExceptionModal({
  open,
  gateMessage,
  busy,
  onCancel,
  onConfirm,
}: CompletionExceptionModalProps) {
  const [reason, setReason] = useState('')

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-5 space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">Complete with exception</h3>
        {gateMessage && (
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3">
            {gateMessage}
          </p>
        )}
        <label className="block text-sm font-medium text-gray-700">
          Exception reason (required)
          <textarea
            className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[96px]"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why are you completing without the full checklist/photos?"
            disabled={busy}
          />
        </label>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm"
            onClick={() => {
              setReason('')
              onCancel()
            }}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!reason.trim() || busy}
            className="px-4 py-2 bg-amber-600 text-white rounded-lg text-sm disabled:opacity-50"
            onClick={async () => {
              const trimmed = reason.trim()
              if (!trimmed) return
              await onConfirm(trimmed)
              setReason('')
            }}
          >
            Complete anyway
          </button>
        </div>
      </div>
    </div>
  )
}
